<template>
  <div class="container-fluid" dir="ltr">
    <!-- <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts> -->
    <apexchart height="350" :options="ApexChartOptions" :series="ApexChartOptions.series"></apexchart>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chartOptions: {
        series: [
          {
            data: [],
            name: 'تعداد تماس در روز',
          },
        ],
        title: {
          text: 'پراکندگی تماسها',
        },
        xAxis: {
          title: {
            text: 'تاریخ',
          },
          categories: [],
          tickInterval: 1,
        },
        yAxis: {
          title: {
            text: 'تعداد تماس',
          },
        },
      },
      ApexChartOptions: {
        chart: {
          type: 'line',
        },
        dataLabels: {
          enabled: false,
        },
        colors: this.config.colors,
        series: [{ type: '', data: [] }],

        stroke: {
          show: true,
          width: 2,
          curve: 'smooth',
        },
        yaxis: {
          title: {
            text: this.config.ytitle,
          },
        },
        xaxis: {
          labels: {
            rotate: -63.5,
          },
          categories: [],
          tickPlacement: 'on',
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40,
        },
      },
    }
  },
  props: ['data', 'config'],
  created() {
    console.log(this.config)
    this.data.forEach((element, index) => {
      element.forEach((value) => {
        if (index == 0) {
          this.chartOptions.xAxis.categories.push(value.date)
        }
        if (this.chartOptions.series[index]) {
          this.chartOptions.series[index].data.push(value.Count)
          this.chartOptions.series[index].name = value.name
          this.ApexChartOptions.series[index].data.push(Number(value.Count))
          this.ApexChartOptions.series[index].type = 'line'
          this.ApexChartOptions.series[index].name = value.name
          this.ApexChartOptions.xaxis.categories.push(value.date)
        } else {
          this.chartOptions.series[index] = {
            data: [],
            name: value.name,
          }
          this.ApexChartOptions.series[index] = {
            type: 'line',
            name: value.name,
            data: [],
          }
          this.ApexChartOptions.series[index].data.push(Number(value.Count))
          this.chartOptions.series[index].data.push(value.Count)
        }
      })
    })
  },
}
</script>

<style>
tspan {
  font-family: 'IRANSansWeb' !important;
}
</style>
